import { ReportingControllerBaseConfig } from '../../../base';
import { DocumentDetailController } from './documentDetailInterface';
import { DocumentDetailViewProps } from './documentDetailProps';
import { AiFillStar, AiOutlineHistory, AiOutlineStar } from 'react-icons/ai';
import { createContentItemController } from '../../../view';
import { useEffect, useMemo } from 'react';
import { BiChat, BiCommentDetail } from 'react-icons/bi';

export function createDocumentDetailController(
    config: ReportingControllerBaseConfig
): DocumentDetailController {
    const {
        kernel: {
            infra: { formatter },
        },
    } = config;

    const itemController = createContentItemController(config);

    return {
        useProps(context, item, props): DocumentDetailViewProps {
            const contentItem = itemController.useProps(context, item.item, props.item);

            useEffect(() => {
                props.event.onLoad(item.document);
            }, [item.document.id]);

            return {
                isAnimating: props.isAnimating,
                favorite: item.favorite
                    ? {
                          isActive: true,
                          button: {
                              onClick() {
                                  return props.bookmark.onRemove(item.favorite!);
                              },
                          },
                          description: 'Remove from favorites',
                          Icon: AiFillStar,
                      }
                    : {
                          isActive: false,
                          button: {
                              onClick() {
                                  return props.bookmark.onAdd();
                              },
                          },
                          description: 'Add to favorites',
                          Icon: AiOutlineStar,
                      },
                actions: [
                    {
                        id: 'history',
                        Icon: AiOutlineHistory,
                        tooltip: {
                            label: `Last edited 3 hours ago by Agent Susie`,
                        },
                        button: {
                            onClick() {
                                console.log('show history');
                            },
                        },
                    },
                    {
                        id: 'comments',
                        Icon: BiCommentDetail,
                        tooltip: {
                            label: 'Show all comments',
                        },
                        button: {
                            onClick() {
                                console.log('show all comments');
                            },
                        },
                    },
                    {
                        id: 'chat',
                        Icon: BiChat,
                        tooltip: {
                            label: props.chat.disclosure.isOpen
                                ? 'Close chat'
                                : 'Open chat',
                        },
                        button: {
                            onClick() {
                                if (props.chat.disclosure.isOpen) {
                                    console.log('close chat');
                                    props.chat.disclosure.onClose();
                                } else {
                                    console.log('open chat');
                                    props.chat.disclosure.onOpen();
                                }
                            },
                        },
                    },
                ],
                item: contentItem,
                editor: props.editor,
                suggestion: props.suggestion
                    ? {
                          accept: {
                              label: 'Accept all',
                              button: {
                                  onClick: props.suggestion.onAccept,
                              },
                          },
                          reject: {
                              label: 'Reject all',
                              button: {
                                  onClick: props.suggestion.onReject,
                              },
                          },
                      }
                    : null,
            };
        },
    };
}
